/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface OccpLogEntry
 */
export interface OccpLogEntry {
    /**
     *
     * @type {string}
     * @memberof OccpLogEntry
     */
    deviceIdentity?: string;
    /**
     *
     * @type {string}
     * @memberof OccpLogEntry
     */
    fileName?: string;
    /**
     *
     * @type {string}
     * @memberof OccpLogEntry
     */
    fileUrl?: string;
    /**
     *
     * @type {number}
     * @memberof OccpLogEntry
     */
    fileSizeBytes?: number;
    /**
     *
     * @type {Date}
     * @memberof OccpLogEntry
     */
    created?: Date;
    /**
     *
     * @type {string}
     * @memberof OccpLogEntry
     */
    status?: OccpLogEntryStatusEnum;
    /**
     *
     * @type {number}
     * @memberof OccpLogEntry
     */
    progressPercentage?: number;
}

/**
 * @export
 */
export const OccpLogEntryStatusEnum = {
    Pending: "Pending",
    Uploading: "Uploading",
    Complete: "Complete",
    Failed: "Failed",
    Unknown: "Unknown",
} as const;
export type OccpLogEntryStatusEnum =
    (typeof OccpLogEntryStatusEnum)[keyof typeof OccpLogEntryStatusEnum];

/**
 * Check if a given object implements the OccpLogEntry interface.
 */
export function instanceOfOccpLogEntry(value: object): value is OccpLogEntry {
    return true;
}

export function OccpLogEntryFromJSON(json: any): OccpLogEntry {
    return OccpLogEntryFromJSONTyped(json, false);
}

export function OccpLogEntryFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): OccpLogEntry {
    if (json == null) {
        return json;
    }
    return {
        deviceIdentity:
            json["deviceIdentity"] == null ? undefined : json["deviceIdentity"],
        fileName: json["fileName"] == null ? undefined : json["fileName"],
        fileUrl: json["fileUrl"] == null ? undefined : json["fileUrl"],
        fileSizeBytes:
            json["fileSizeBytes"] == null ? undefined : json["fileSizeBytes"],
        created:
            json["created"] == null ? undefined : new Date(json["created"]),
        status: json["status"] == null ? undefined : json["status"],
        progressPercentage:
            json["progressPercentage"] == null
                ? undefined
                : json["progressPercentage"],
    };
}

export function OccpLogEntryToJSON(value?: OccpLogEntry | null): any {
    if (value == null) {
        return value;
    }
    return {
        deviceIdentity: value["deviceIdentity"],
        fileName: value["fileName"],
        fileUrl: value["fileUrl"],
        fileSizeBytes: value["fileSizeBytes"],
        created:
            value["created"] == null
                ? undefined
                : value["created"].toISOString(),
        status: value["status"],
        progressPercentage: value["progressPercentage"],
    };
}
